import axios from "axios";
// import { handleAlert, handleLoading } from "components/utils/comm";
import axiosInstance from "./axiosInstens";
import { alertControl, loadControl } from "util/commAction";

export type IResponse =
  | {
      status: {
        code: number;
        dtlCode: string;
        message: string;
      };
      data: any;
    }
  | any;

type IProps = {
  method: "post" | "get";
  url: string;
  data?: object;
};

const api = async ({ method, url, data }: IProps) => {
  // 페이이지 로딩
  loadControl({
    isLoading: true,
    text: "Loading",
  });

  alertControl({
    isOpen: false,
    inner: "",
  });

  try {
    axios.defaults.withCredentials = true;
    const response = await axiosInstance({
      method,
      url: url,
      data,
    });

    const res: IResponse = response.data;

    //settimeout

    return res;
    return {} as IResponse;
  } catch (error: any) {
    console.error("error", error);
    //   setTimeout(() => {
    //     handleLoading({
    //       type: "post",
    //       isOpen: false,
    //     });
    //   }, 200);

    //   handleAlert({
    //     isOpen: true,
    //     inner: error?.message,
    //   });
  }
};

export default api;
